<template>
<div>
  <div class="flex mt-5">
    <!-- Columna Izquierda - Drawings -->
    <div :class="[( documentId || checkedRows.length > 0 ? 'w-8/12' : 'w-full'), 'mr-2']">
      <!-- Tabla de Drawings -->
      <div class="panel">
        <div v-if="isLoading" class="my-4 text-center">
          <scale-loader></scale-loader>
        </div>
        <div v-else>
          <div class="flex flex-wrap w-full mt-4">
          <section class="w-full">
            <b-table
              icon-pack="fas"
              :data="documents"
              :paginated="isPaginated"
              :per-page="perPage"
              :bordered="true"
              :current-page.sync="currentPage"
              :pagination-simple="isPaginationSimple"
              :default-sort-direction="defaultSortDirection"
              v-if="!isLoading"
              >
              <template>
                <b-table-column field="thumbnail" cell-class="w-6 vertical-center" sortable>
                  <template v-slot:header="">{{ $t('thumbnail') }}</template>
                  <template v-slot="props">
                    <div class="flex flex-wrap justify-center">
                      <img v-if="isImage(props.row)"
                        :src="props.row.document.file.thumbnail"
                        class="p-1 bg-white border rounded"
                        :alt="props.row.description"
                        onerror="'this.src=\''+asset('public/thumb.jpeg')+'\''"
                      />
                      <img v-else
                        :src="asset('public/thumb.jpeg')"
                        class="p-1 bg-white border rounded"
                        :alt="props.row.description"
                    />
                    </div>
                  </template>
                </b-table-column>

                <b-table-column field="name" cell-class="vertical-center" sortable>
                  <template v-slot:header="">{{ $t('name') }} / {{ $t('description') }}</template>
                  <template v-slot="props">{{ props.row.document.original_filename }}<br> {{ props.row.description }}</template>
                </b-table-column>

                <b-table-column field="file" cell-class="w-6 vertical-center" centered>
                  <template v-slot:header="">{{ $t('file') }}</template>
                  <template v-slot="props">
                    <b-tooltip :label="$t('download_document')" position="is-top">
                      <div class="cursor-pointer text-blue-light">
                          <a class="button is-rounded is-link" @click="downloadDoc(props.row.document_id)">
                              <span class="icon">
                                <i class="fas fa-file"></i>
                              </span>
                          </a>
                      </div>
                    </b-tooltip>
                  </template>
                </b-table-column>

                <b-table-column field="actions" cell-class="vertical-center" width=100 sortable>
                  <template v-slot:header="">{{ $t('actions') }}</template>
                  <template v-slot="props">
                    <div class="flex items-center justify-around w-full h-full">

                      <b-tooltip :label="$t('delete')" position="is-left" type="is-danger">
                          <div @click="removeDocument(props.row)"
                              class="flex cursor-pointer text-red">
                            <b-icon pack="fas" icon="trash-alt"/>
                          </div>
                      </b-tooltip>
                    </div>
                  </template>
                </b-table-column>
              </template>

              <template slot="bottom-left">
                  <b-icon pack="fas" class="flex text-blue" icon="folder"></b-icon>
                  <b>{{ $t("total") }}</b>: {{ this.documents.length }}
              </template>

              <template #empty>
                  <div class="has-text-centered">{{ $t('no_results') }}</div>
              </template>

            </b-table>
          </section>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
</template>

<script>

import axios from "axios";
import { mapGetters } from 'vuex';
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default {
  name: "project-documents-report",

  components: {
    ScaleLoader,
  },

  props: {
    projectId: { type: Number, required: true },
  },

  data: () => ({
    isLoading: true,
    page: 1,
    perPage: 25,
    total: 0,
    orderField: "reference_code",
    orderDir: "asc",
    currentPage: 1,
    defaultSortDirection: 'asc',
    isPaginationSimple: false,
    isPaginated: true,

    documents: [],
    checkedRows: [],

    // values
    documentId: null,


    valuesInEdition: [], // valor que estan en modo edicion. Editor inline
    disableSaveButton: false,
    loaded: false,
    loadingAssigned: false,
    processingData: false,

    showPanel: 'none',

    fileName: '',
    errorFields: {},

    showPdfEditor: false, // determines if company has this module available
  }),


  watch: {
  },

  mounted() {
    this.getProjectDocuments();
    this.path = window.location.origin + '/' + this.path;
    this.errorFields = {
      activity: 'DSO',
      validation: this.$t('validation_flow'),
      validationTask: this.$t('task')
    };


    // Check module pdfEditor availability for this company
    if (this.company.configs
      && this.company.configs.modules
      && this.company.configs.modules.includes('pdfEditor')) {
        this.showPdfEditor = true;
    } else {
        this.showPdfEditor = true; // always true for now...
    }
  },

  computed: {
    ...mapGetters({
      company: 'app/company',
    }),
  },

  methods: {
    async getProjectDocuments() {
      this.isLoading = true;
      let params = {
      };

      const { data } = await axios.get(
        "/api/v2/project/" + this.projectId + "/document-reports",
        { params: params }
      );

      if (data && data.success) {
        this.documents = data.documents;
        this.total = data.documents ? data.documents.length : 0;
      } else {
        this.$notify.error("error_loading_documents");
      }
      this.isLoading = false;
    },

    reload() {
      this.getProjectDocuments();
    },

    isImage(row) {
      const mime = row.document?.mime_type || ''
      return mime.startsWith('image/')
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async removeDocument(doc) {
      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_generic", [doc.document.original_filename]),
        confirmText: this.$t("delete"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.documentId = null

          this.isLoading = true;
          let url = "/api/v2/document-report/" + doc.id;
          const { data } = await axios.delete(url);

          if (data.success) {
            this.$toast.open({
              message: this.$t("success_deleting_generic"),
              type: "is-success",
              position: "is-top-right"
            });
            await this.sleep(1000);
            this.reload();
          } else {
            this.isLoading = false;
            // Error
            this.$toast.open({
              message: data.msg || data.error || this.$t("error_saving"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
        }
      });
    },

    async downloadDoc(document_id) {
      this.$notify.success("starting_download_document");
      let url = "/api/v2/document/" + document_id;

      const {data} = await axios.get(url);

      if (data) {
        window.open(data.data);
      } else {
        this.$notify.error("error_download_document");
      }
    },


  }
};
</script>

<style scoped>
  .b-table::v-deep .table .checkbox-cell {
    vertical-align: middle !important;
    text-align: center;
  }

  .b-table::v-deep .table .checkbox-cell .checkbox {
    background-color: white !important;
    padding: 0;
    margin: 0;
    border-radius: 5px;
    width: 20px;
  }

  .b-checkbox.checkbox:not(.button) {
    margin-right: 0 !important;
  }
</style>
